var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.statusColor,domProps:{"textContent":_vm._s(_vm.statuses[_vm.status])}})}
var staticRenderFns = []

export { render, staticRenderFns }